const saveStoryboard = async (project) =>{

    const saveToDb = async (updatedProject) =>{
        const projectId = project._id;
        try{
            const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'
            const response = await fetch(`${API_BASE_URL}/saveProject`, {
                method:'POST',
                credentials:'include',
                headers:{
                    'Content-Type': 'application/json',
                    "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                },
                body:JSON.stringify({projectId, updatedProject}),
            });
            const result = await response.json();
            if(response.ok){
                console.log('Project saved successfully:', result);
                return 'Success';
            } else {
                console.error('Error saving project:', result);
                return 'Error';
            }
        } catch(error){
            console.error('Error: ', error)
            return 'Error';
        }
    }

    
    const result = await saveToDb(project);
    return result;
}

export default saveStoryboard